module.exports = __webpack_public_path__ + "img/job_08.cfd97feb.png";